export default function insertNodeAfterBlockWithId(editor, blockId, node) {
  const block = editor.value.document.findDescendant(node => {
    return node.getIn(['data', 'id']) === blockId
  })

  if (!block) {
    // give up
    return false
  }

  // insert the embed block after our target block
  const path = editor.value.document.getPath(block.key)
  return editor.insertNodeByPath(path.butLast(), path.last() + 1, node)
}
